import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import SearchArea from "./area/search";
import WordListArea from "./area/list";

function TextBookManageWordCoolPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    g_par_id: "",
    g_par_seq: "",
    ...props
  };

  let default_cont_class_arr = ["4-skills", "VOCA"];
  const [listOpt, setListOpt] = useState({
    "order_id": "cont_no",
    s_contents_group: "Pairing",
    s_cont_class: ["VOCA"],
    s_include: "Y",
    s_book_no: "20000",
    s_cont_book_like_after: "30_1",
    s_cont_unit: "Unit_08",
    s_cont_part: "word",//stc
    s_addon_url_prefix: "1",
    "is_paging": "",
    max_limit_num: "1000",
  });
  const [cont_book_info, set_cont_book_info] = useState<any>({});
  const [word_info_arr, set_word_info_arr] = useState<any>([]);
  const [url_prefix, set_url_prefix] = useState("");

  useEffect(() => {
    if (myProps.g_par_id == "contents_book" && myProps.g_par_seq) {
      get_cont_book_info_by_ajax({
        s_uid: myProps.g_par_seq
      });
    }
    //get_word_by_ajax({});
  }, []);

  const get_cont_book_info_by_ajax = (inData: any) => {
    let opt_obj = {
      s_uid: myProps.g_par_seq,
      ...inData
    };
    if (strFunc.is_empty(opt_obj.s_uid)) {
      return false;
    }
    let form_json_data: any = {
      s_uid: opt_obj.s_uid
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/coolen_con_book/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length == 0) {
            alert("학습 자료가 없습니다..");
          } else {
            let cont_book_info = response.data["data"]["info_arr"][0];
            set_cont_book_info(cont_book_info);
            let s_cont_book_like_after = "";
            let s_cont_book_like_arr = cont_book_info.cont_book.split(" ");
            if (s_cont_book_like_arr.length > 0) {
              s_cont_book_like_after = s_cont_book_like_arr[s_cont_book_like_arr.length - 1];
            }
            // s_book_no: cont_book_info.book_no,
            // s_cont_book_like_after: s_cont_book_like_after,
            // s_cont_unit: cont_book_info.cont_unit,
            get_word_by_ajax({
              s_book_no: cont_book_info.book_no,
              s_cont_book_like_after: s_cont_book_like_after,
              s_cont_unit: cont_book_info.cont_unit,
            });
          }
        } else {

        }
      });
  };

  const get_word_by_ajax = (inData: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inData
    };
    setListOpt(tmp_list_opt);

    if (strFunc.is_empty(tmp_list_opt.s_book_no)
      || strFunc.is_empty(tmp_list_opt.s_cont_book_like_after)
      || strFunc.is_empty(tmp_list_opt.s_cont_unit)) {
      set_word_info_arr([]);
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/coolen_con/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_url_prefix(response.data["data"]["url_prefix"]);
          set_word_info_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const add_new_row = () => {
    if (word_info_arr.length == 0) {
      alert("최소 1개이상 있어야 합니다.");
      return false;
    }
    if (listOpt.s_include == "N") {
      alert("사용안함 상태에서는 추가할 수 없습니다.");
      return false;
    }
    if (listOpt.s_cont_part == "") {
      alert("컨텐츠 구분을 선택해주세요.");
      return false;
    }
    let last_info: any = word_info_arr[word_info_arr.length - 1];
    let new_info: any = { ...last_info };
    let last_cont_no = strFunc.uncomma_int(last_info.cont_no);
    last_cont_no++;
    new_info.uid = "";
    new_info.cont_no = last_cont_no;
    new_info.e_script = "";
    new_info.k_script = "";
    new_info.mp3_file = "";
    new_info.mp3_file_url = "";
    let change_word_info_arr = [...word_info_arr];
    change_word_info_arr.push(new_info);
    set_word_info_arr(change_word_info_arr);
  };

  const save_word_by_ajax = (inData: any) => {
    let opt_obj = {
      word_info_arr: word_info_arr,
      ...inData
    };
    if (opt_obj.word_info_arr.length == 0) {
      return false;
    }

    let write_word_arr: any = [];
    for (let i = 0; i < opt_obj.word_info_arr.length; i++) {
      let info = opt_obj.word_info_arr[i];
      if (strFunc.is_empty(info.e_script) || strFunc.is_empty(info.k_script)) {
        alert("단어 또는 뜻이 비어있는 항목이 있습니다. 확인후 다시저장해주세요.");
        return false;
      }
      write_word_arr.push(info);
    }

    if (confirm("저장하시겠습니까?") === false) {
      return false;
    }

    let form_json_data: any = {
      data_arr: opt_obj.word_info_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/coolen_con/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장되었습니다.");
          get_word_by_ajax({});
        } else {
          alert("저장에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  const delete_word_by_ajax = (inData: any) => {
    let opt_obj = {
      del_word_arr: [],
      ...inData
    };
    let del_word_arr: any = [];
    for (let i = 0; i < opt_obj.del_word_arr.length; i++) {
      let info = opt_obj.del_word_arr[i];
      if (!strFunc.is_empty(info.uid)) {
        del_word_arr.push(info);
      }
    }
    if (del_word_arr.length == 0) {
      alert("삭제할 단어를 선택해주세요.");
      return false;
    }

    if (confirm("삭제하시겠습니까?") === false) {
      return false;
    }

    let form_json_data: any = {
      data_arr: del_word_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/coolen_con/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("삭제되었습니다.");
          get_word_by_ajax({});
        } else {
          alert("삭제에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        get_word_by_ajax={get_word_by_ajax}
      ></SearchArea>
      <div className="mt-1">
        <WordListArea
          word_info_arr={word_info_arr}
          set_word_info_arr={set_word_info_arr}
          url_prefix={url_prefix}
          delete_word_by_ajax={delete_word_by_ajax}
        ></WordListArea>
      </div>
      <div className="my_flex_center mt-3">
        <button className="btn btn-dark"
          onClick={() => {
            save_word_by_ajax({});
          }}
        >저장</button>
        <button className="btn btn-dark"
          onClick={() => {
            add_new_row();
          }} >신규단어추가</button>
        <button
          className="btn btn-dark"
          onClick={() => myProps.closePopup()}
        >
          닫기
        </button>
      </div>
    </div>
  );
};
export default TextBookManageWordCoolPopupArea;